(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/skeleton/result-coupon-fallback.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/skeleton/result-coupon-fallback.js');
"use strict";

const _svs$components$lbUi = svs.components.lbUi,
  SkeletonLine = _svs$components$lbUi.SkeletonLine,
  SkeletonCircle = _svs$components$lbUi.SkeletonCircle;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const CouponHolderFallback = () => {
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_SM));
  const numberOfMatches = [...Array(8).keys()];
  const circleSize = isWideScreen ? 35 : 20;
  return React.createElement("div", {
    className: "skeleton-result-coupon table-holder"
  }, numberOfMatches.map(match => React.createElement("div", {
    key: match
  }, React.createElement("div", {
    className: "skeleton-result-coupon-container skeleton-result-coupon"
  }, React.createElement("div", {
    className: "skeleton-result-coupon-upper-row"
  }, React.createElement("div", {
    className: "skeleton-result-coupon-left-column"
  }, React.createElement(SkeletonCircle, {
    size: circleSize
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-teamNames"
  })), React.createElement("div", {
    className: "skeleton-result-coupon-right-column"
  }, React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-timestate"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast"
  }))), React.createElement("div", {
    className: "skeleton-result-coupon-lower-row"
  }, React.createElement("div", {
    className: "skeleton-result-coupon-left-column"
  }, React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-svenskafolket-text"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-odds-text"
  })), React.createElement("div", {
    className: "skeleton-result-coupon-right-column"
  }, React.createElement("div", {
    className: "skeleton-result-coupon-odds-container"
  }, React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast skeleton-result-coupon-odds"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast skeleton-result-coupon-odds"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast skeleton-result-coupon-odds"
  })), React.createElement("div", {
    className: "skeleton-result-coupon-odds-container"
  }, React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast skeleton-result-coupon-odds"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast skeleton-result-coupon-odds"
  }), React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-forecast skeleton-result-coupon-odds"
  }))))), React.createElement("div", {
    className: "skeleton-result-coupon-divider"
  }))), React.createElement("div", {
    className: "skeleton-result-coupon-net-sales"
  }, React.createElement(SkeletonLine, {
    className: "skeleton-result-coupon-net-sales-line"
  })));
};
setGlobal('svs.components.tipsen.routeResult.CouponHolderFallback', CouponHolderFallback);

 })(window);